import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ColumnModel from '../../../../../../models/datasource/column';
import {FEATURE_FLAGS} from '../../../../../../services/feature_flags';
import {
    columnLeaveEvent,
    columnHoverEvent,
    columnSelectEvent,
    inputSubmitEvent,
    focusNewAttributeEvent,
} from '../../../../../../services/query_builder_events';
import {queryBuilderState} from '../../../../../../services/query_builder_state';
import {ATTRIBUTES, QUERY_BUILDER_TYPES} from '../../../../../../utils/query_utils';

export default class SchemaBrowserColumn extends Component {
    column = null;

    constructor(props) {
        super(props);

        this.onHover = this.onHover.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    componentDidMount() {
        this.unbindColumnSubmitEvent = inputSubmitEvent.listen(() => {
            if (this.props.hovered || this.props.selected) {
                if (
                    FEATURE_FLAGS.QUERY_BUILDER_TYPE !== QUERY_BUILDER_TYPES.SINGLE_INPUT &&
                    queryBuilderState.attribute.type !== ATTRIBUTES.FILTER
                ) {
                    const unbindListener = columnSelectEvent.listen((__, hadColumn) => {
                        if (!hadColumn) {
                            focusNewAttributeEvent.emit();
                        }
                        unbindListener();
                    });
                }
                this.onSelect();
            }
        });
    }

    componentWillUnmount() {
        this.unbindColumnSubmitEvent();
    }

    onHover() {
        columnHoverEvent.emit(this.props.column);
    }

    onLeave() {
        columnLeaveEvent.emit(this.props.column);
    }

    onSelect() {
        columnSelectEvent.emit(this.props.column);
    }

    getLabel() {
        return this.props.column.label;
    }

    render() {
        const {column, hovered, selected} = this.props;
        const {onHover, onLeave, onSelect} = this;
        return (
            <li
                className={`column-item ${column.type.toLowerCase()} ${hovered || selected ? 'hover' : ''}`}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
                onClick={onSelect}
                ref={(el) => { this.column = el; }}
            >
                {this.getLabel()}
            </li>
        );
    }
}

SchemaBrowserColumn.propTypes = {
    column: PropTypes.instanceOf(ColumnModel).isRequired,
    selected: PropTypes.bool,
    hovered: PropTypes.bool,
};

SchemaBrowserColumn.defaultProps = {
    selected: false,
    hovered: false,
};
